"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _richText = require("@eventmobi/rich-text");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _styles.makeStyles)({
  container: {
    width: 'inherit',
    height: 'inherit',
    overflowY: 'auto',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    lineHeight: 1,
    paddingTop: '2px'
  }
}, {
  name: 'Mui-WidgetText'
});

var Text = (_ref) => {
  var {
    richText,
    color: backgroundColor,
    image,
    onClick = () => {}
  } = _ref;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container,
    style: {
      backgroundImage: image ? "url(".concat(image, ")") : 'none',
      backgroundColor
    }
  }, /*#__PURE__*/_react.default.createElement(_richText.Renderer, {
    content: richText,
    onClick: onClick
  }));
};

Text.propTypes = {
  /**
   * This is the html content
   */
  richText: _propTypes.default.string,

  /**
   * Background color of container
   */
  color: _propTypes.default.string,

  /**
   * Background image of container
   */
  image: _propTypes.default.string,

  /**
   * Handle click for anchor tags in content
   */
  onClick: _propTypes.default.func
};
var _default = Text;
exports.default = _default;